import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import es from './locales/es.json'
import zhTW from './locales/zh-TW.json'
import zhCN from './locales/zh-CN.json'
import ja from './locales/ja.json'
import ko from './locales/ko.json'
import pt from './locales/pt.json'
import ru from './locales/ru.json'
import fi from './locales/fi.json'
import sv from './locales/sv.json'
import et from './locales/et.json'
import da from './locales/da.json'
import de from './locales/de.json'
import fr from './locales/fr.json'
import it from './locales/it.json'
import nb from './locales/nb.json'
import vi from './locales/vi.json'
import ar from './locales/ar.json'
import he from './locales/he.json'
import yi from './locales/yi.json'
import id from './locales/id.json'
import hi from './locales/hi.json'

/** 从右到左书写的语言（RTL） */
export const RTL_LANGUAGES = ['ar', 'he', 'yi']

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      'zh-TW': { translation: zhTW },
      'zh-CN': { translation: zhCN },
      ja: { translation: ja },
      ko: { translation: ko },
      pt: { translation: pt },
      ru: { translation: ru },
      fi: { translation: fi },
      sv: { translation: sv },
      et: { translation: et },
      da: { translation: da },
      de: { translation: de },
      fr: { translation: fr },
      it: { translation: it },
      nb: { translation: nb },
      vi: { translation: vi },
      ar: { translation: ar },
      he: { translation: he },
      yi: { translation: yi },
      id: { translation: id },
      hi: { translation: hi }
    },
    fallbackLng: 'en',
    debug: false,
    // 默认使用英文：只信任用户之前在语言菜单里手动选过的语言（存在 localStorage），
    // 不根据浏览器/系统语言自动切换，避免非英文系统的用户打开就看到别的语言。
    detection: {
      order: ['localStorage'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false // React 已经安全处理了 XSS
    }
  })

function applyDocumentDirection(lang: string) {
  const isRTL = RTL_LANGUAGES.includes(lang)
  document.documentElement.dir = isRTL ? 'rtl' : 'ltr'
  document.documentElement.lang = lang
}

applyDocumentDirection(i18n.language)
i18n.on('languageChanged', applyDocumentDirection)

export default i18n
